const extractHeadPose = (dirs) => {
  const {
    faceUp: faceUpDir,
    faceForward: faceForwardDir,
    neck: neckDir
  } = dirs
  return {
    headUpDir: faceUpDir,
    headForwardDir: faceForwardDir,
    neckDir
  }
}

const extractBodyPose = (shouldersCenter, hipsCenter, lengths, dirs) => {
  const {
    shoulderSpace,
    hipSpace
  } = lengths
  const {
    shoulderForward: shoulderForwardDir,
    shoulderUp: shoulderUpDir,
    hipForward: hipForwardDir,
    hipUp: hipUpDir
  } = dirs

  return {
    shoulder: {
      center: shouldersCenter,
      spacing: shoulderSpace,
      forwardDir: shoulderForwardDir,
      upDir: shoulderUpDir
    },
    hip: {
      center: hipsCenter,
      spacing: hipSpace,
      forwardDir: hipForwardDir,
      upDir: hipUpDir
    }
  }
}

const extractLeftArmPose = (lengths, dirs) => {
  return {
    ik: {
      length: lengths.rootEndArmLeftLength,
      dir: dirs.shoulderWrist
    },
    fk: {
      rootDir: dirs.shoulder,
      middleDir: dirs.elbow
    },
    endDir: dirs.wrist,
    tipFaceDir: dirs.palm
  }
}

const extractRightArmPose = (lengths, dirs) => {
  return {
    ik: {
      length: lengths.rootEndArmRightLength,
      dir: dirs.shoulderWrist
    },
    fk: {
      rootDir: dirs.shoulder,
      middleDir: dirs.elbow
    },
    endDir: dirs.wrist,
    tipFaceDir: dirs.palm
  }
}

const extractLeftLegPose = (lengths, dirs) => {
  return {
    ik: {
      length: lengths.rootEndLegLeftLength,
      dir: dirs.hipAnkle
    },
    fk: {
      rootDir: dirs.hip,
      middleDir: dirs.knee
    },
    endDir: dirs.ankle
  }
}

const extractRightLegPose = (lengths, dirs) => {
  return {
    ik: {
      length: lengths.rootEndLegRightLength,
      dir: dirs.hipAnkle
    },
    fk: {
      rootDir: dirs.hip,
      middleDir: dirs.knee
    },
    endDir: dirs.ankle
  }
}

const convertBlazePose = ({ confidence, primary }, confidenceCutoff) => {
  if (!(confidence && primary)) {
    throw new Error('Unexpected data structure')
  }

  const isHeadConfident = confidence.head > confidenceCutoff
  const isArmLeftConfident = confidence.armLeft > confidenceCutoff
  const isArmRightConfident = confidence.armRight > confidenceCutoff
  const isLegLeftConfident = confidence.legLeft > confidenceCutoff
  const isLegRightConfident = confidence.legRight > confidenceCutoff
  if (!(isHeadConfident ||
        isArmLeftConfident ||
        isArmRightConfident ||
        isLegLeftConfident ||
        isLegRightConfident)) {
    return {}
  }

  const {
    shouldersCenter,
    hipsCenter,
    lengths,
    dirs
  } = primary

  const headPose = isHeadConfident
    ? extractHeadPose(dirs)
    : {}

  const bodyPose = confidence.body > confidenceCutoff
    ? extractBodyPose(shouldersCenter, hipsCenter, lengths, dirs)
    : {}

  const armLeftPose = isArmLeftConfident
    ? extractLeftArmPose(lengths, dirs.left)
    : {}

  const armRightPose = isArmRightConfident
    ? extractRightArmPose(lengths, dirs.right)
    : {}

  const legLeftPose = isLegLeftConfident
    ? extractLeftLegPose(lengths, dirs.left)
    : {}

  const legRightPose = isLegRightConfident
    ? extractRightLegPose(lengths, dirs.right)
    : {}

  const {
    upperArmLength,
    lowerArmLength,
    handLength,
    upperLegLength,
    lowerLegLength,
    ankleHeight,
    footLength
  } = lengths

  return {
    isLeftPositive: true,
    head: headPose,
    body: bodyPose,
    arm: {
      upperArmLength,
      lowerArmLength,
      handLength,
      left: armLeftPose,
      right: armRightPose
    },
    leg: {
      upperLegLength,
      lowerLegLength,
      ankleHeight,
      footLength,
      left: legLeftPose,
      right: legRightPose
    }
  }
}

export { convertBlazePose }
